/**
 * The app's view: 'farmer' (the simple view) or 'admin' (the tools).
 *
 * REQUIREMENTS C2/C3 (George 2026-10-02): an admin account, the client's
 * included, opens in the simple farmer view and sees only its own data; the
 * admin tools are one explicit switch away. The mode is sent on every API
 * request (config/axios.js, header X-TerraMind-View) and the backend treats
 * the account as a farmer for that request (myproject/permissions.is_admin),
 * so every list follows one rule instead of a scope flag per page.
 *
 * A new storage key: the old one defaulted to 'admin' and was read in five
 * places on its own.
 */
const KEY = 'terraMindViewMode.v2';

export function getViewMode() {
  try {
    return localStorage.getItem(KEY) === 'admin' ? 'admin' : 'farmer';
  } catch (_) {
    return 'farmer';
  }
}

export function storeViewMode(mode) {
  try { localStorage.setItem(KEY, mode === 'admin' ? 'admin' : 'farmer'); } catch (_) { /* private mode */ }
}
